import React from 'react';

export function CreateBudgetModal({ totalBudget, setTotalBudget, onSubmit, onClose, title = 'Create Budget', submitLabel = 'Create' }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="budget-goal-modal">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">{title}</h3>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Budget Goal ($)</label>
            <p className="text-sm text-gray-500 mb-2">Set a target amount. Contributions will fund the actual budget.</p>
            <input
              type="number"
              step="0.01"
              min="0"
              value={totalBudget}
              onChange={(e) => setTotalBudget(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-600 focus:border-transparent"
              required
              data-testid="budget-amount-input"
            />
          </div>
          <div className="flex space-x-4">
            <button
              type="button"
              onClick={onClose}
              data-testid="cancel-budget-btn"
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              data-testid="submit-budget-btn"
            >
              {submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
